var _path, _ellipse, _path2, _path3, _path4, _g, _g2, _path5, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgServiceIcon1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 150,
    viewBox: "0 0 200 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.6265 88.6573C11.8729 60.9837 18.7078 35.2679 32.5221 23.2105C46.3364 11.1531 68.8641 6.3896 94.0181 28.8527C119.172 51.3157 163.012 26.6966 175.948 39.6329C188.884 52.5693 183.499 93.0073 147.452 116.491C95.3157 150.457 38.6585 114.879 25.6265 88.6573Z",
    fill: "#F3EBDE"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 97.9142,
    cy: 49.5362,
    rx: 28.3326,
    ry: 28.3712,
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M97.9147 15.1924C114.387 15.1924 127.738 27.9795 127.738 43.7551C127.738 47.9486 126.797 51.9287 125.1 55.5093C123.274 52.8307 121.023 50.5859 118.442 48.7749C118.42 48.7612 118.406 48.7474 118.392 48.7336C115.055 46.5232 112.863 42.8393 112.863 38.6595V36.2082C112.863 39.4101 111.568 42.316 109.469 44.4988C107.132 46.9226 103.803 48.4444 100.093 48.4444L77.2436 48.7267C74.7631 49.133 72.6636 52.6035 70.7367 55.4956C69.0327 51.9218 68.0908 47.9417 68.0908 43.7551C68.0908 27.9795 81.4425 15.1924 97.9147 15.1924Z",
    fill: "#E6D3BA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M92.3225 76.4141H103.506L105.37 82.3869H90.4585L92.3225 76.4141Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M97.9144 80.8936C71.5604 80.8936 50.1963 106.298 50.1963 137.636H145.633C145.633 106.298 124.268 80.8936 97.9144 80.8936Z",
    fill: "#CFAE80"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_1493_3232)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 59.1436,
    y: 86.8667,
    width: 77.542,
    height: 50.7695,
    rx: 5,
    fill: "#E6D3BA"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_1493_3232)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 90.4585,
    y: 104.785,
    width: 14.9119,
    height: 14.9322,
    rx: 7.45596,
    fill: "white"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M67.5325 65.8843H67.8085C70.794 65.8843 73.215 63.3999 73.215 60.3233V49.24C73.215 47.0645 71.9857 45.1851 70.2044 44.2712C70.9696 29.2875 83.0999 17.3289 97.902 17.3289C112.704 17.3289 124.847 29.2875 125.612 44.2841C123.831 45.198 122.602 47.0645 122.602 49.2529V60.3362C122.602 61.0699 122.74 61.7522 122.99 62.3958C119.842 64.7129 115.251 66.3606 110.095 66.8111C109.518 65.8971 108.514 65.2921 107.373 65.2921H103.07C101.276 65.2921 99.8338 66.7854 99.8338 68.6133C99.8338 70.4412 101.276 71.9344 103.07 71.9344H107.373C108.627 71.9344 109.694 71.2007 110.233 70.1322C116.229 69.6431 121.447 67.7765 125.11 64.9961C125.951 65.5496 126.942 65.8843 128.021 65.8843H128.297C131.282 65.8843 133.703 63.3999 133.703 60.3233V49.24C133.703 47.0259 132.449 45.1208 130.617 44.2454C129.814 26.4427 115.451 12.2056 97.902 12.2056C80.3527 12.2056 66.0021 26.4427 65.2118 44.2454C63.3929 45.1337 62.126 47.0388 62.126 49.2529V60.3362C62.126 63.3999 64.547 65.8843 67.5325 65.8843Z",
    fill: "#CFAE80"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_1493_3232",
    x: 59.1436,
    y: 86.8667,
    width: 77.542,
    height: 50.7695,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.8625 0 0 0 0 0.758699 0 0 0 0 0.614531 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1493_3232"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_1493_3232",
    x: 88.4585,
    y: 102.785,
    width: 18.9121,
    height: 18.9321,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.841667 0 0 0 0 0.742981 0 0 0 0 0.606701 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1493_3232"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1493_3232",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgServiceIcon1);
export default __webpack_public_path__ + "static/media/serviceIcon_1.edd3e7387f7dacecd9617ba878e3eb32.svg";
export { ForwardRef as ReactComponent };